import { PropsWithChildren } from 'react';

import Drawer from '@mui/material/Drawer';

import { ESdkEvents } from '../../contracts';
import { sendFEEvent } from '../../eventUtil';
import { useCheckout } from '../../hooks/use-checkout';
import { useAppConfig } from '../../hooks/use-app-config';
import { usePartialScreen } from './hooks/use-partial-screen';
import { mobileSDKUtils } from '../../utils/mobile-sdk-utils';
import { useDeviceHelper } from '../../hooks/use-device-helper';
import { getIsNewMobileLandscape } from '../../utils/get-is-new-mobile-landscape';

const IS_NEW_MOBILE_LANDSCAPE = getIsNewMobileLandscape();

export function Slider({ children, open }: PropsWithChildren<{ open: boolean }>) {
  const { isMobile, isMobileLandscape } = useDeviceHelper();
  const { getEventParams } = useCheckout();
  const isPartialScreen = usePartialScreen();
  const { featureFlags } = useAppConfig();

  const showMobileOpenCloseAnimation =
    isMobile && (featureFlags?.checkout_open_close_animation || mobileSDKUtils.isMobileSdk());

  const mobileSDKCheckoutStyle = mobileSDKUtils.getCheckoutStyle();
  return (
    <Drawer
      open={showMobileOpenCloseAnimation ? open : true}
      onTransitionExited={() => {
        if (!open) {
          sendFEEvent(ESdkEvents.CLOSE_CHECKOUT, {
            ...getEventParams(),
          });
        }
      }}
      transitionDuration={showMobileOpenCloseAnimation ? 300 : 0}
      SlideProps={{ appear: showMobileOpenCloseAnimation }}
      anchor="bottom"
      hideBackdrop
      sx={{
        backgroundColor: mobileSDKCheckoutStyle.overlayBackgroundColor
          ? mobileSDKCheckoutStyle.overlayBackgroundColor
          : 'rgba(0, 0, 0, 0.75)',
      }}
      className={`${isMobileLandscape && IS_NEW_MOBILE_LANDSCAPE ? 'mobile-landscape' : ''} ${
        IS_NEW_MOBILE_LANDSCAPE ? 'new-mobile-layout' : ''
      }`}
      PaperProps={{
        sx: {
          backgroundColor: 'initial',
          height: '100%',
          maxHeight: isPartialScreen ? '90%' : '100%',
          justifyContent: 'center',
        },
      }}
    >
      {children}
    </Drawer>
  );
}
